import { Form } from 'antd';
import { useCallback } from 'react';
import { useNotificationMessages } from 'hooks/useNotificationMessages';
import { useUpdateSupplierOfferItemMutation } from 'api';
import { useParams } from 'react-router-dom';

export const useMarkNotAvailableModal = ({
  originalItemId,
  onCancel,
  type,
}: {
  originalItemId?: string;
  type: string | undefined;
  onCancel: () => void;
}) => {
  const { supplierOfferId } = useParams() as { supplierOfferId: string };
  const [form] = Form.useForm();
  const { handleSuccess, handleError } = useNotificationMessages();
  const [updateSupplierOfferItem, { isLoading }] = useUpdateSupplierOfferItemMutation();
  const onModalCancel = useCallback(() => {
    onCancel();
  }, [onCancel]);

  const onFinish = useCallback(async () => {
    try {
      const { data, error } = await updateSupplierOfferItem({
        data: [
          {
            id: originalItemId,
            item: {
              itemNumber: originalItemId,
              itemActionType: type === 'NOT_AVAILABLE' ? 'AVAILABLE' : 'NOT_AVAILABLE',
            },
          },
        ],
        supplierOfferId,
      });
      if (data?.success) {
        handleSuccess(`Item was successfully marked as ${type === 'NOT_AVAILABLE' ? 'Available' : 'Not Available'}.`);
        onModalCancel();
      } else {
        handleError(error);
      }
    } catch (err) {
      handleError(err);
    }
  }, [handleError, handleSuccess, originalItemId, updateSupplierOfferItem, onModalCancel, supplierOfferId, type]);
  return { form, onFinish, isLoading, onCancel, onModalCancel };
};
